module.exports = __webpack_public_path__ + "img/locatario-1.8bf71411.svg";